import React from 'react'
interface PopUpProps {
    isVisible: boolean
    onClose: () => void
    title?: string
    deletePrivilege: () => void
}

const AddPrivilegetoRoleDelete: React.FC<PopUpProps> = ({
    isVisible,
    onClose,
    title,
    deletePrivilege,
}) => {
    if (!isVisible) return null

    return (
        <>
            <div className="ui-widget-overlay ui-front" style={{ zIndex: 100 }}></div>
            <div
                tabIndex={-1}
                role="dialog"
                className="ui-dialog ui-corner-all ui-widget ui-widget-content ui-front ui-dialog-buttons"
                aria-describedby="delete_privilege_wrapper"
                aria-labelledby="ui-id-3"
                style={{
                    height: 'auto',
                    width: '350px',
                    top: '50%',
                    left: '50%',
                    position: 'fixed',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 101,
                }}
            >
                <div className="ui-dialog-titlebar ui-corner-all ui-widget-header ui-helper-clearfix">
                    <span id="ui-id-3" className="ui-dialog-title">
                        {title}
                    </span>
                    <button
                        type="button"
                        className="ui-button ui-corner-all ui-widget ui-button-icon-only ui-dialog-titlebar-close"
                        title="Close"
                        onClick={onClose}
                    >
                        <span className="ui-button-icon ui-icon ui-icon-closethick"></span>
                        <span className="ui-button-icon-space"> </span>Close
                    </button>
                </div>
                <div
                    id="delete_privilege_wrapper"
                    className="ui-dialog-content ui-widget-content"
                    style={{
                        display: 'block',
                        width: 'auto',
                        minHeight: '42.28px',
                        maxHeight: 'none',
                        height: 'auto',
                    }}
                >
                    <div className="panel-popup-window">
                        <p>Are you sure you want to remove this privilege for this role?</p>
                        <br />
                        <p>
                            Access to this privilege will be removed from all the users in this
                            role.
                        </p>
                        <br />
                        <strong>This operation cannot be undone.</strong>
                    </div>
                </div>
                <div className="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
                    <div className="ui-dialog-buttonset">
                        <button
                            type="button"
                            className="ui-button ui-corner-all ui-widget app-button negative"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="ui-button ui-corner-all ui-widget app-button"
                            onClick={deletePrivilege}
                        >
                            Remove Privilege
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddPrivilegetoRoleDelete
